"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marone": {
    "6bd735d1": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "25d98905": [{
      "hkey": "9c97947c",
      "slug": "marone",
      "name": "Marone",
      "primary": true,
      "skipSearch": false
    }],
    "ariolo": [{
      "hkey": "9c97947c",
      "slug": "marone",
      "name": "Marone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a3cc240": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "skipSearch": false
    }],
    "collepiano": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "07e5ba8d": [{
      "hkey": "99aa8ba3",
      "slug": "monte-marone",
      "name": "Monte Marone",
      "primary": true,
      "skipSearch": false
    }],
    "montemarone": [{
      "hkey": "99aa8ba3",
      "slug": "monte-marone",
      "name": "Monte Marone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2d80b78b": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "skipSearch": false
    }],
    "ponzano": [{
      "hkey": "8b29bb51",
      "slug": "centro-ariolo",
      "name": "Centro-Ariolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;